import { useUpdateEffect } from 'react-use';

import { ReceptionServiceWithPractitionersSimpleQuery } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { useBoolean } from '@dreryk/react-common';

import { ReceptionServiceCreateModal } from './ReceptionServiceCreateModal';

type ReceptionServiceCreateModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => JSX.Element;

type ReceptionServiceCreateModalOpenerProps = {
   readonly children: ReceptionServiceCreateModalOpenerRenderer;
};

export const ReceptionServiceCreateModalOpener = (props: ReceptionServiceCreateModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   useUpdateEffect(() => {
      if (!modalOpened) {
         refetchCqrsQuery(ReceptionServiceWithPractitionersSimpleQuery);
      }
   }, [modalOpened]);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}
         {modalOpened ? <ReceptionServiceCreateModal onSuccess={closeModal} onClose={closeModal} /> : null}
      </>
   );
};
